<template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">Name</th>
          <th class="text-left">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(relay, index) in relays"
          :key="index"
        >
          <td>{{ relay.settings.name }}</td>
          <td>
            <v-switch
              @change="switchRelay(relay)"
              v-model="relay.value"
            ></v-switch>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
  <!-- <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">Raum hinzufügen</v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Raum hinzufügen</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field label="Name*" v-model="room.name" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field label="Betriebsmodus" v-model="room.operatingMode" required></v-text-field>
              </v-col>             
              <v-col cols="12" sm="6" md="4">
                <v-text-field label="Sollwert" v-model="room.setPoint" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field label="Istwert" v-model="room.currentTemp" required></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close()">Schließen</v-btn>
          <v-btn color="blue darken-1" text @click="save()">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
</template>

<script>
export default {
  name: 'Relays',

  data: () => ({
    relays: [],
    dialog: false
  }),

  created () {
    this.getRelays()
    setInterval(() => {
      this.getRelays()
    }, 2000)
  },
  methods: {
    getRelays () {
      this.$http.get('/api/unipi/relays').then((response) => {
        this.relays = response.data
      })
    },
    save () {
      this.$http.post('/api/relays', this.room).then(() => {
        this.close()
      })
    },
    switchRelay (relay) {
      this.$http.post('/api/unipi/relays/switch', relay).then(() => {
        this.getRelays()
      })
    },
    close () {
      this.dialog = false
      this.initRoom()
    }
  }

};
</script>
